export const CONSTANT_ADA = "3|ΨΥΠ1ΟΞ7Μ-Δ7Ψ";
export const CONSTANT_ANATHETOUSA = "1015.E00460.0001";

export const ADA_OPTIONS = [
    {label: "3|ΨΥΠ1ΟΞ7Μ-Δ7Ψ", value: "3|ΨΥΠ1ΟΞ7Μ-Δ7Ψ"},
    {label: "3|6ΚΟΥΟΞ7Μ-ΘΥ0", value: "3|6ΚΟΥΟΞ7Μ-ΘΥ0"},
    {label: "3|6ΝΑΞΟΞ7Μ-Η5Ε", value: "3|6ΝΑΞΟΞ7Μ-Η5Ε"},
]